export default "__VITE_ASSET__9570ddea__"